



























































































import {
  computed,
  defineComponent,
  ref,
  ssrRef,
  useContext,
  useFetch,
  useRoute,
} from '@nuxtjs/composition-api';
import { SfBreadcrumbs, SfSelect } from '@storefront-ui/vue';
import LazyHydrate from 'vue-lazy-hydration';

import { useFacet, useUiHelpers, useUiState } from '~/composables';
import type { Pagination } from '~/composables/types';
import { useAddToCart } from '~/helpers/cart/addToCart';
import CategoryNavbar from '~/modules/catalog/category/components/navbar/CategoryNavbar.vue';
import CategoryPagination from '~/modules/catalog/category/components/pagination/CategoryPagination.vue';
import type { SortingModel } from '~/modules/catalog/category/composables/useFacet/sortingOptions';
import facetGetters from '~/modules/catalog/category/getters/facetGetters';
import type { Product } from '~/modules/catalog/product/types';
import { Breadcrumb } from '~/modules/catalog/types';
import type { Aggregation, ProductInterface } from '~/modules/GraphQL/types';
import { useWishlist } from '~/modules/wishlist/composables/useWishlist';

export default defineComponent({
  name: 'BrandResult',
  components: {
    CategoryPagination,
    CategoryEmptyResults: () =>
      import('~/modules/catalog/category/components/CategoryEmptyResults.vue'),
    CategoryFilters: () =>
      import(
        '~/modules/catalog/category/components/filters/CategoryFilters.vue'
      ),
    // CmsContent: () => import('~/modules/catalog/category/components/cms/CmsContent.vue'),
    CategoryProductGrid: () =>
      import(
        '~/modules/catalog/category/components/views/CategoryProductGrid.vue'
      ),
    CategoryNavbar,
    SfSelect,
    LazyHydrate,
    SfBreadcrumbs,
  },
  transition: 'fade',
  setup() {
    const {
      localePath,
      app: { i18n },
    } = useContext();
    const route = useRoute();
    const {
      params: { id: brandID },
    } = route.value; // brandID =  brand name
    const uiHelpers = useUiHelpers();
    const isShowProducts = ref(false);
    const products = ssrRef<ProductInterface[]>([]);
    const sortBy = ref<SortingModel>({ selected: '', options: [] });
    const pagination = ref<Pagination>({});
    const productContainerElement = ref<HTMLElement | null>(null);
    const aggregation = ref<Array<Aggregation>>([]);
    const brandName = computed(() => {
      if (brandID) {
        return brandID.replace(/-/g, ' ').replace('.html', '');
      }
      return '';
    });
    const breadcrumbs = ref<Breadcrumb[]>([
      {
        text: i18n.t('Home') as string,
        link: localePath('/'),
      },
      {
        text: i18n.t('Brand') as string,
        link: localePath('/brand'),
      },
      {
        text: brandName.value as unknown as string,
        link: localePath(''),
      },
    ]);
    const subCategory = ref<Array<String>>([
      'Skincare',
      'makeup',
      'fragrance-women',
      'fragrance-men',
      'Sales',
    ]);

    const { toggleFilterSidebar, isCategoryGridView, isFilterSidebarOpen } =
      useUiState();
    const {
      addItem: addItemToWishlistBase,
      isInWishlist,
      removeItem: removeItemFromWishlist,
    } = useWishlist();
    const { result, search } = useFacet();

    const { addItemToCart } = useAddToCart();

    const addItemToWishlist = async (product: Product) => {
      await (isInWishlist({ product })
        ? removeItemFromWishlist({ product })
        : addItemToWishlistBase({ product }));
    };

    const { fetch } = useFetch(async () => {
      aggregation.value = [];
      isShowProducts.value = true;
      const searchObj = { ...uiHelpers.getFacetsFromURL() };
      if (
        searchObj &&
        searchObj.filters &&
        searchObj.filters.ref &&
        searchObj.filters.ref.length > 0
      ) {
        searchObj.filters.brands = searchObj.filters.ref;
        delete searchObj.filters.ref;
      }
      console.log('seach obj', searchObj);
      await search(searchObj);

      products.value = facetGetters.getProducts(result.value) ?? [];
      sortBy.value = facetGetters.getSortOptions(result.value);
      pagination.value = facetGetters.getPagination(result.value);
      aggregation.value = facetGetters.getAggregation(result.value);
    });

    const isPriceLoaded = ref(true);

    const goToPage = (page: number) => {
      uiHelpers.changePage(page, false);
      fetch();
    };

    const doChangeItemsPerPage = (itemsPerPage: number) => {
      uiHelpers.changeItemsPerPage(itemsPerPage, false);
      goToPage(0);
    };

    const onReloadProducts = () => {
      goToPage(0);
      productContainerElement.value.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    };

    return {
      isPriceLoaded,
      ...uiHelpers,
      toggleFilterSidebar,
      isCategoryGridView,
      isFilterSidebarOpen,
      addItemToCart,
      addItemToWishlist,
      pagination,
      products,
      sortBy,
      isShowProducts,
      doChangeItemsPerPage,
      productContainerElement,
      onReloadProducts,
      goToPage,
      aggregation,
      breadcrumbs,
      brandName,
      subCategory,
    };
  },
  // head() {
  //   return getMetaInfo(this.categoryMeta);
  // },
});
